"use strict";

var BIW_ENVIRONMENT = process.env.BIW_ENVIRONMENT;
var getEnv = function getEnv() {
  if (!BIW_ENVIRONMENT && window) {
    if (window.location.origin.indexOf('://localhost') >= 0) {
      return 'qa';
    }
    var nonProd = window.location.hostname.toLowerCase().split('.').find(function (chunk) {
      return ['qa', 'pprd'].indexOf(chunk) >= 0;
    });
    return nonProd || '';
  }
  if (BIW_ENVIRONMENT === 'pprd') {
    return 'pprd';
  } else if (BIW_ENVIRONMENT === 'prod') {
    return '';
  }
  return 'qa';
};
function getURL(url, overrideUrl) {
  if (overrideUrl) {
    return overrideUrl;
  }
  return url.toLowerCase().replace('(env.)', env ? env + '.' : '');
}
var env = getEnv();
var getSharedServicesUrl = function getSharedServicesUrl(overrideUrl) {
  if (overrideUrl) {
    return overrideUrl;
  }
  if (BIW_ENVIRONMENT === 'prod') {
    return 'https://bankservices.biworldwide.com/banqsharedservices/services';
  }
  return 'https://bankservicespprd.biworldwide.com/banqsharedservices/services';
};
module.exports = {
  getUrlForEnvironment: getURL,
  authUrl: getURL('https://(env.)api.biw.cloud/v1/auth', process.env.BIW_AUTH_URL),
  cashierUrl: getURL('https://(env.)api.biw.cloud/v1/cashier', process.env.BIW_CASHIER_URL),
  cmxUrl: getURL('https://(env.)api.biw.cloud/v2/cmx', process.env.BIW_CMX_URL),
  companiesUrl: getURL('https://(env.)api.biw.cloud/v1/company-service', process.env.BIW_COMPANIES_URL),
  channelsUrl: getURL('https://(env.)api.biw.cloud/v1/channels', process.env.BIW_CHANNELS_URL),
  dataLoaderUrl: getURL('https://(env.)api.biw.cloud/dataloader/services/v1', process.env.BIW_DATA_LOADER_URL),
  emailUrl: getURL('https://(env.)api.biw.cloud/v1/emails', process.env.BIW_EMAIL_URL),
  giftCodeUrl: getURL('https://(env.)api.biw.cloud/v1/gift-code', process.env.BIW_GIFT_CODE_URL),
  imagesUrl: getURL('https://(env.)api.biw.cloud/v1/images', process.env.BIW_IMAGES_URL),
  harryUrl: getURL('https://(env.)api.biw.cloud/v1/harry', process.env.BIW_HARRY_URL),
  idUrl: getURL('https://(env.)api.biw.cloud/v1/id', process.env.BIW_ID_URL),
  mtcUrl: getURL('https://(env.)api.biw.cloud/v1/mtc-ingest/v1/upload-video', process.env.BIW_MTC_URL),
  permissionsUrl: getURL('https://(env.)api.biw.cloud/v1/permissions-manager', process.env.PERMISSIONS_URL),
  profileUrl: getURL('https://(env.)api.biw.cloud/v1/profile', process.env.BIW_PROFILE_URL),
  pushNotificationsUrl: getURL('https://(env.)api.biw.cloud/v1/push-notification-service', process.env.BIW_PUSH_NOTIFICATIONS_URL),
  rosterUrl: getURL('https://(env.)api.biw.cloud/v1/roster', process.env.BIW_ROSTER_URL),
  schemaControlUrl: getURL('https://(env.)api.biw.cloud/schemacontrol/services/v1', process.env.BIW_SCHEMA_CONTROL_URL),
  serviceAwardsUrl: getURL('https://(env.)api.biw.cloud/v1/service-awards', process.env.BIW_SERVICE_AWARDS_URL),
  timelineUrl: getURL('https://(env.)api.biw.cloud/v1/timeline', process.env.BIW_TIMELINE_URL),
  recognitionUrl: getURL('https://(env.)api.biw.cloud/v2/recognition', process.env.BIW_RECOGNITION_URL),
  tokenUrl: getURL('https://(env.)api.biw.cloud/token/services/v1', process.env.BIW_TOKEN_URL),
  rewardMatrixUrl: getURL('https://(env.)api.biw.cloud/rewardmatrix/v1', process.env.BIW_REWARD_MATRIX_URL),
  arcadeUrl: getURL('https://(env.)api.biw.cloud/arcadeapi/services/v1', process.env.BIW_ARCADE_URL),
  kameUrl: getURL('https://(env.)api.biw.cloud/kameapi', process.env.BIW_KAME_URL),
  exchangeUrl: getURL('https://(env.)api.biw.cloud/v1/exchange', process.env.BIW_EXCHANGE_URL),
  kadhavuUrl: getURL('https://(env.)api.biw.cloud/v1/kadhavu', process.env.BIW_KADHAVU_URL),
  schemaRegistryUrl: getURL('https://(env.)api.biw.cloud/schema-registry', process.env.BIW_SCHEMA_REGISTRY_URL),
  rosterProxyAdminUrl: getURL('https://(env.)api.biw.cloud/v1/roster-proxy-admin', process.env.BIW_ROSTER_PROXY_ADMIN_URL),
  brandingUrl: getURL('https://(env.)api.biw.cloud/v1/branding', process.env.BIW_BRANDING_URL),
  briksUrl: getURL('https://(env.)api.biw.cloud/briks', process.env.BIW_BRIKS_URL),
  chromeIntegrationUrl: getURL('https://(env.)api.biw.cloud/v1/chrome-integration', process.env.BIW_CHROME_INTEGRATION_URL),
  experienceRegistryUrl: getURL('https://(env.)api.biw.cloud/experience-registry-api', process.env.BIW_EXPERIENCE_REGISTRY_URL),
  profileExperienceUrl: getURL('https://(env.)api.biw.cloud/v1/profile-exp-api', process.env.BIW_PROFILE_EXPERIENCE_URL),
  towerExperienceUrl: getURL('https://(env.)api.biw.cloud/v1/tower-exp-api', process.env.BIW_TOWER_EXPERIENCE_URL),
  kadhavuExperienceUrl: getURL('https://(env.)api.biw.cloud/v1/kadhavu-exp-api', process.env.BIW_KADHAVU_EXPERIENCE_URL),
  cmxExperienceUrl: getURL('https://(env.)api.biw.cloud/v1/cmx-exp-api', process.env.BIW_CMX_EXPERIENCE_URL),
  navigationUrl: getURL('https://(env.)api.biw.cloud/v1/navigation', process.env.BIW_NAVIGATION_URL),
  budgetUrl: getURL('https://(env.)api.biw.cloud/v1/budget', process.env.BIW_BUDGET_URL),
  privacyUrl: getURL('https://(env.)api.biw.cloud/privacyapi/services/v1', process.env.BIW_PRIVACY_URL),
  piersUrl: getURL('https://(env.)api.biw.cloud/v1/piers', process.env.BIW_PIERS_URL),
  rosterExperienceUrl: getURL('https://(env.)api.biw.cloud/v1/roster-exp-api', process.env.BIW_ROSTER_EXPERIENCE_URL),
  serviceAwardsExperienceUrl: getURL('https://(env.)api.biw.cloud/v1/service-awards-exp', process.env.BIW_SERVICE_AWARDS_EXPERIENCE_URL),
  giftCodeExperienceUrl: getURL('https://(env.)api.biw.cloud/v1/gift-code-exp', process.env.BIW_GIFT_CODE_EXPERIENCE_URL),
  solutionsUrl: getURL('https://(env.)api.biw.cloud/solutionapi/services/v1', process.env.SOLUTIONS_URL),
  notificationUrl: getURL('https://(env.)api.biw.cloud/notification-service/v1', process.env.BIW_NOTIFICATION_URL),
  notificationEmailUrl: getURL('https://(env.)api.biw.cloud/v1/notification-email-service', process.env.BIW_NOTIFICATION_EMAIL_URL),
  jsTransformUrl: getURL('https://(env.)api.biw.cloud/v1/js-transform', process.env.BIW_JS_TRANSFORM_URL),
  pdfUrl: getURL('https://(env.)api.biw.cloud/v1/pdf', process.env.BIW_PDF_URL),
  catalogSSOUrl: getURL('https://(env.)api.biw.cloud/catalog/sso/services/v1', process.env.BIW_CATALOG_SSO_URL),
  sharedServicesUrl: getSharedServicesUrl(process.env.BIW_SHARED_SERVICES_URL),
  // no qa url
  slackIntegrationUrl: getURL('https://(env.)api.biw.cloud/v1/slack-integration', process.env.BIW_SLACK_INTEGRATION_URL),
  hosedUpUrl: getURL('https://(env.)api.biw.cloud/v1/hosed-up', process.env.BIW_HOSED_UP_URL),
  behaviorUrl: getURL('https://(env.)api.biw.cloud/v1/behavior', process.env.BIW_BEHAVIOR_URL),
  celebrationMomentsUrl: getURL('https://(env.)api.biw.cloud/v1/celebrations', process.env.BIW_CELEBRATION_MOMENTS_URL),
  //TODO: remove when company-setup goes away
  companyUrl: getURL('https://(env.)api.biw.cloud/v1/company-setup', process.env.BIW_COMPANY_URL)
};
//# sourceMappingURL=endpoints.js.map